import { Fragment } from 'react';

import Input from '@usas/ui-web/components/inputs/Input';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubRegistrationScreeningPoliciesWrite = ({ handleSubmit, formState, errorState, onFormValueChanged }) => (
  <Fragment>
    <form onSubmit={handleSubmit} noValidate>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>Pre-Employment Screening</b>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <p style={{marginLeft: '5px', color: '#041e42'}}>Per 2.6.10 of the USA Swimming Corporate Bylaws, all clubs are required to comply with 
            USA Swimming Pre-Employment Screening Procedures for New Employees for all new employees who 
            are required to be members under these Bylaws.</p>
          <p>&nbsp;<a href="https://www.usaswimming.org/safe-sport/club-tool-kit/preemployment-screening" target="_blank" rel="noreferrer">Click here to view more on Pre-Employment Screening</a></p>
          <YesNoSwitch
            label=""
            name="preEmploymentScreeningRequired"
            checked={formState.preEmploymentScreeningRequired}
            error={errorState.preEmploymentScreeningRequired}
            message={errorState.preEmploymentScreeningRequired}
            onChange={(value) => { onFormValueChanged('preEmploymentScreeningRequired', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>Racing Start Certification</b>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <YesNoSwitch
            label="By selecting yes and signing below, I formally acknowledge that this club complies 
              with all Racing Start Certification requirements as stated in the USA Swimming Rules &amp; 
              Regulations, Article 103.2.2 and maintains records for its athlete members."
            checked={formState.racingStartCertified}
            error={errorState.racingStartCertified}
            message={errorState.racingStartCertified}
            onChange={(value) => { onFormValueChanged('racingStartCertified', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>State Concussion Laws</b>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <YesNoSwitch
            label="By selecting yes and signing below, I formally acknowledge that this club is following 
              the state concussion laws regarding training coaches and providing educational information to 
              athletes, parents, and guardians as required."
            checked={formState.stateConcussionsLaws}
            error={errorState.stateConcussionsLaws}
            message={errorState.stateConcussionsLaws}
            onChange={(value) => { onFormValueChanged('stateConcussionsLaws', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>Minor Athlete Abuse Prevention Policy</b>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <p style={{marginLeft: '5px', color: '#041e42'}}>By selecting yes and signing below, I formally acknowledge that this club 
            has implemented USA Swimming Minor Athlete Abuse Prevention Policy, and require all athletes, 
            parents, coaches, and other non-athlete members of the club to review and agree to the Policy on 
            an annual basis with such written agreement to be retained by the club.</p>
          <p>&nbsp;<a href="https://www.usaswimming.org/safe-sport/minor-athlete-abuse-prevention-policy" target="_blank" rel="noreferrer">For more information regarding MAAPP, click here</a></p>
          <YesNoSwitch
            label=""
            checked={formState.minorAthleteAbusePreventionPolicy}
            error={errorState.minorAthleteAbusePreventionPolicy}
            message={errorState.minorAthleteAbusePreventionPolicy}
            onChange={(value) => { onFormValueChanged('minorAthleteAbusePreventionPolicy', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>Application Acknowledgement</b>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <YesNoSwitch
            label="By completing this process, I acknowledge that we will comply with all USA Swimming policies, 
            code of conduct, rules, regulations as well as federal, state and local jurisdictions at all times 
            while operating a club within USA Swimming."
            checked={formState.applicationAcknowledgement}
            error={errorState.applicationAcknowledgement}
            message={errorState.applicationAcknowledgement}
            onChange={(value) => { onFormValueChanged('applicationAcknowledgement', value) }} />
        </div>
      </div>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <b>Screening & Policies Signature</b>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label="Acknowledgements Signature*"
            name="acknowledgementsSignature"
            value={formState.acknowledgementsSignature}
            error={errorState.acknowledgementsSignature}
            message={errorState.acknowledgementsSignature}
            onChange={(value) => {
              onFormValueChanged('acknowledgementsSignature', value);
              onFormValueChanged('acknowledgementsSignatureDate', formState.today);
            }}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <ReadOnly
            label="Signature Date"
            name="acknowledgementsSignatureDate"
            value={formState.acknowledgementsSignatureDate} />
        </div>
      </div>
    </form>
    {errorState.general &&
      <div className="row">
        <div className="col-xs-12">
          <p className={global.ErrorMessage}>{errorState.general ? errorState.general : ''}</p>
        </div>
      </div>}
  </Fragment>
);


export default ClubRegistrationScreeningPoliciesWrite;